import React from 'react';
import ReactSVG from 'react-svg';
import { FormattedHTMLMessage } from 'react-intl';
import classnames from 'classnames';
import { NeuroMessage, useNeuroMessages } from '@ignitesales/neuro-application';

const Footer = ({ classname, isSummaryPage }) => {
  const pageCssBEM = 'footer';
  const classes = classnames(pageCssBEM, classname);
  const containerClass = classnames('container', { summaryFooter: isSummaryPage });
  const { getMessage } = useNeuroMessages();

  return <footer className={classes}>
    <div className={containerClass}>
      {isSummaryPage && <div className={`${pageCssBEM}__logos with-border`}><ReactSVG src="/classpath/assets/images/logo.svg" /></div>}
      <div className={`${pageCssBEM}__nmls`}>
        <NeuroMessage id="nmls" />
      </div>
      <div className={`${pageCssBEM}__logos`}>
        <ReactSVG src="/classpath/assets/images/fdic-logo.svg" />
      </div>
      <div className={`${pageCssBEM}__privacy`}>
        <FormattedHTMLMessage id="privacy" />
      </div>
    </div>
  </footer>;
};

export default Footer;
